import React from 'react';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').LargeImage}
 */
const LargeImage = ({
    image,
    video,
    caption
}) => {
    // render
    return (
        <>
            <div className='width-100vw trunk-full-width'>
                <figure>
                    <div>
                        {video ? (
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                src={video.videoUrl}/>
                        ) : (
                            <Image {...image} />
                        )}
                    </div>
                </figure>
            </div>
            {caption &&
                <figcaption className='col-6 md-col-8 mt4'>
                    <div
                        className='rich-text type-style-7'
                        dangerouslySetInnerHTML={{__html: caption}} />
                </figcaption>
            }
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default LargeImage;
